var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadRounded(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 260.002,
    height: 49.311,
    viewBox: "0 0 260.002 49.311",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_33",
    "data-name": "Union 33",
    d: "M-14991.311-12975.7c-4.384.141-9.73-1.078-15.411-5.4-10.569-9.351-23.851-8.781-23.851-8.781H-15049v-.03h116v.03h-19.046s-13.282-.569-23.854,8.781c-5.393,4.11-10.485,5.415-14.743,5.415C-14990.867-12975.688-14991.091-12975.691-14991.311-12975.7Zm-129.69-14.216V-13015a10,10,0,0,1,10-10h240a10,10,0,0,1,10,10v25.084Z",
    transform: "translate(15121.001 13024.999)",
    fill: "#172645"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadRounded);
export default __webpack_public_path__ + "static/media/uploadRounded.0c0945118cd9b75c24ee275af0b06865.svg";
export { ForwardRef as ReactComponent };